import React from 'react';

import { SharedMenu } from 'modules/shared-menu/types';

export type SelectionInfoContextProps = {
  country: Country;
  selection: SharedMenu;
  vlmeConfig?: {
    isSingleVenue: boolean;
    isSharedVenue: boolean;
    venueId: string;
  };
};

const SelectionInfoContext = React.createContext<SelectionInfoContextProps | null>(null);

export const useSelectionInfoContext = () => {
  const selectionInfo = React.useContext(SelectionInfoContext);

  if (!selectionInfo) {
    throw new Error('useSelectionInfoContext must be used within SelectionInfoContextProvider');
  }

  return selectionInfo;
};

export const SelectionInfoContextProvider = SelectionInfoContext.Provider;
